const url = import.meta.env.VITE_APP_API_ACCOUNT
export default {
    actions: {
        fetchAccounts: async ({ commit, dispatch }) => {
            return dispatch("fetchAuth", {
                url: `${url}/account/list`,
                option: {method: "GET", headers: {"Content-Type": "application/json"}},
                action: {name: "fetchAccounts", data: {}}
            }).then(
                result => {
                    if(result.code === 200) {
                        for (let account in result.data.items) {
                            commit('SET_ACCOUNT', result.data.items[account])
                        }
                        dispatch('connectAccount')
                    }
                },
                error => {
                    throw Error(error.message)
                })
            /*
            return fetchAuth(`${url}/account/list`, {
                method: 'GET',
                headers: {'Content-Type': 'application/json'},
            }).then(
                result => {
                    if(result.code === 200) {
                        for (let account in result.data.items) {
                            commit('SET_ACCOUNT', result.data.items[account])
                        }
                        dispatch('connectAccount')
                    }
                },
                error => {
                    throw Error(error.message)
                }
            )*/
        },
        fetchAccount: async ({ commit, getters, dispatch }, currency) => {
            return dispatch("fetchAuth", {
                url: `${url}/account/${currency}`,
                option: {method: "GET", headers: {"Content-Type": "application/json"}},
                action: {name: "fetchAccount", data: currency}
            }).then(result => {
                if(result.code === 200) {
                    commit('SET_ACCOUNT', result.data)
                    return result.data
                }
                return {balance: 0}
            })
            /*
            try {
                return fetchAuth(`${url}/account/${currency}`, {
                    method: 'GET',
                    headers: {'Content-Type': 'application/json'},
                }).then(result => {
                        if(result.code === 200) {
                            commit('SET_ACCOUNT', result.data)
                            return result.data
                        }
                    })
            } catch (e) {
                return {balance: 0}
            }
*/
        },

    },
    mutations: {
        SET_ACCOUNT(state, account) {
            let property = {}
            property[account.currency] = account.balance
            state.accounts =  {...state.accounts, ...property}
        },
        SET_ACCOUNTS(state, accounts) {
            state.accounts = accounts
        },
        SOCKET_ONMESSAGE(state, message) {
            if(message.t === "b") {
                let property = {}
                property[message.c] = message.b

                state.accounts =  {...state.accounts, ...property}
            }
        },
    },
    state: {
        accounts: {},
    },
    getters: {
        getAccounts:(state) => state.accounts,
        getAccountBalance: (state) => (currency) => {
            return state.accounts[currency] === undefined ? 0 :  state.accounts[currency]
        }
    }
}